/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */

/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8 = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8.__super__.call(this);
};
/* __super__ is defined below, and used above :)
 * This is OK because below is operated at load time (as is the definition of the constructor).
 * Above is operated at construction time.
 */
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8,		// The extend defines the __super__
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8"
                 );

/** resizeToViewportFocused - Resize the chat area when we have focus and the virtual keyboard is in view
 *
 * Form MOB-721
 * Please note: this can be called when we do not have a resized canvas, so we must:
 *  1) get the current area of the Application for the width and height
 *  2) Check the width and height of the viewport to see if it has changed
 *  3) If it has changed, and only if it has changed then
 *     a) set the new area via Application.SetArea
 *     b) resize
 *     c) scroll the transcript down.
 *
 * @private
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8.prototype.resizeToViewportFocused = function() {
	/** @type {Window} */
	var clientWin = window.parent;
	/** @type {com.inq.utils.Area} */
	var oldSize = Application.GetArea();
	this.viewPort = com.inq.utils.Capabilities.getViewport();
///This line is different from the super (ancestor) ///	this.viewPort.h = this.iOS8ViewableHeight;

	haxe.Log.trace("viewport height: " + this.viewPort.h, { fileName : "ChatTextFocusMonitorImplCRiOS8.js", lineNumber : 1239, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8", methodName : "resizeToViewportFocused"});

	Application.SetArea(this.viewPort);

	this.zoomViewport(clientWin);
	/* Check to see if the viewport has changed, if it hasn't we do not want to set the area, resize and scroll the transcript down */
	if (this.viewPort.h != oldSize.h || this.viewPort.w != oldSize.w){

		com.inq.utils.Timer.delay(function() {

			com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
			/**
			 * this is to Syncronize scroll events occuring due to keyboard up, and manual scrollTo code
			 */
			Application.Resize();

		}, 100);
	}
};

/**
 * onFocusImpl - Restore the original scroll position & chat dimensions.
 *
 * This is currently (as of MOB-599) a bucket to hold everything that
 * needs to be moved into subclasses.
 *
 * @public
 * @param {FocusEvent} ev
 * @param {HTMLElement} element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8.prototype.onFocusImpl = function(ev, element) {
	/* super.onFocusImpl */
	var retVal = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplCRiOS8.__super__.prototype.onFocusImpl.call(this, ev, element);
	this.onScrollCallback();
	return retVal;
};
